import { Pagination } from 'antd';
import { ComponentType } from 'react';
import { styled } from 'styled-components';
import { PaginationProps } from './types';

export const StyledPagination = styled(Pagination as ComponentType<any>)<PaginationProps>`
  &.ant-pagination {
    display: initial;
  }

  .ant-pagination-item-active {
    background-color: ${props => props.theme.colors.primary.main.filled};
    border-color: transparent !important;
  }

  .ant-pagination-item:hover {
    background-color: ${props => props.theme.colors.primary.light.linearHover} !important;
    border-color: transparent !important;
  }

  .ant-pagination-item a {
    color: ${props => props.theme.colors.secondary.main.text} !important;
    font-weight: 400;
    font-size: 14px;
    height: 32px;
    width: 32px;
  }

  .ant-pagination-item-active a {
    color: ${props => props.theme.colors.primary.main.text} !important;
  }
  .ant-pagination-item:hover a {
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }

  .ant-pagination-item.ant-pagination-item-active:hover {
    background-color: ${props => props.theme.colors.primary.main.hover} !important;
    border-color: transparent !important;
  }
  .ant-pagination-item.ant-pagination-item-active:hover a {
    color: ${props => props.theme.colors.primary.main.text} !important;
  }

  .ant-pagination-item-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .ant-pagination-item-link:hover {
    background-color: ${props => props.theme.colors.primary.light.linearHover} !important;
  }

  .ant-pagination-item-link .anticon,
  .ant-pagination-item-link .anticon svg {
    width: 16px;
    height: 16px;
  }

  .ant-pagination-disabled:hover .ant-pagination-item-link,
  .ant-pagination-disabled .ant-pagination-item-link {
    background-color: transparent !important;
    color: ${props => props.theme.colors.neutral.light.text} !important;
  }

  .ant-pagination-jump-prev:hover a,
  .ant-pagination-jump-next:hover a {
    border-radius: 4px !important;
    height: 100%;
  }

  .ant-pagination-jump-prev:hover a .ant-pagination-item-container,
  .ant-pagination-jump-next:hover a .ant-pagination-item-container {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .ant-pagination-item-ellipsis {
    margin-left: -5px !important;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    color: ${props => props.theme.colors.secondary.main.text};

    &:hover {
      background-color: ${props => props.theme.colors.primary.light.linearHover};
    }
    &[disabled] {
      color: ${props => props.theme.colors.neutral.light.text} !important;
      cursor: not-allowed;
      &:hover {
        background-color: transparent !important;
      }
    }
  }

  .ellipsis {
    color: ${props => props.theme.colors.neutral.light.text} !important;
  }
`;
